<template>
  <chip :get-status="getStatus" />
</template>

<script>
import Chip from './components/Chip.vue';

export default {
  name: 'SituacaoPagamentoColumn',
  components: { Chip },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    status: {
      rejeitado: {
        color: '#FAF6EA',
        textColor: 'warning',
        label: 'Rejeitado',
      },
      efetivado: {
        color: '#EAFAF5',
        textColor: 'success',
        label: 'Efetivado',
      },
      baixada: {
        color: '#FF7043',
        textColor: 'deep-orange lighten-5',
        label: 'Baixada',
      },
      erro_no_pagamento: {
        color: '#FAEAEB',
        textColor: 'error',
        label: 'Erro no pagamento',
      },
    },
  }),
  computed: {
    getStatus() {
      return this.verifyStatus;
    },
    verifyStatus() {
      if (this.value) {
        return this.status[this.formatValue] || this.adpaterValue;
      }

      return this.adpaterNullableValue;
    },
    formatValue() {
      return this.value.trim()
        .replace(' ', '_')
        .toLowerCase();
    },
    adpaterValue() {
      return {
        label: this.value,
        color: '#CFD8DC',
        textColor: 'blue-grey darken-3 ',
      };
    },
    adpaterNullableValue() {
      return {
        label: this.value,
        color: '#fff',
        textColor: 'blue-grey darken-3',
      };
    },
  },
};
</script>
